<template>
  <div class="width-80">
    <div class="text-align-center">
      <h1>Join us on our Comms!</h1>
    </div>
    <div class="text-align-justify">
      <p class="text-align-justify">
        Lorem ipsum dolor sit amet consectetur adipiscing elit, sed do eiusmod tempor
        incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris
        nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum
        dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia
        deserunt mollit anim id est laborum.
      </p>

      <div class="container">
        <div class="text-align-center">
          <iframe src="" width="350" height="500" allowtransparency="true" frameborder="0"></iframe>
          <iframe name="ts3monitor.com" allowtransparency="true" width="350" height="500" frameborder="0" style="border:0px solid #;" scrolling="auto" src=""></iframe>    </div>

        </div>
      </div>
  </div>
</template>

<script>

export default {
  name: "Comms"
}


</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/info/Comms.vue